import { useEffect, useState } from "react";
import API from "../../services/api";
import "./MatchesPage.css";

function MatchesPage() {
  const [matches, setMatches] = useState([]);
  const [selectedMatch, setSelectedMatch] = useState(null);
  const [search, setSearch] = useState("");
  const [countryFilter, setCountryFilter] = useState("");
  const [timeUntilStartFilter, setTimeUntilStartFilter] = useState("");
  const [accessFilter, setAccessFilter] = useState("");
  const [displayFilter, setDisplayFilter] = useState("");
  const [dateFilter, setDateFilter] = useState("");

  // LOAD MATCHES
  useEffect(() => {
    fetchMatches();
  }, []);

  const fetchMatches = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await API.get("/matches/admin", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setMatches(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const importMatches = async () => {
    try {
      const today = new Date();
      const todayStr = today.toISOString().split("T")[0];

      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      const tomorrowStr = tomorrow.toISOString().split("T")[0];

      await Promise.all([
        API.post("/matches/import", { date: todayStr }),
        API.post("/matches/import", { date: tomorrowStr }),
      ]);

      alert("Matchs importés ✅");
      fetchMatches();
    } catch (error) {
      console.log(error);
    }
  };

  const toggleCouponPool = async (id) => {
    try {
      await API.put(`/coupons/coupon-pool/${id}`);
      fetchMatches();
    } catch (error) {
      console.log(error);
    }
  };

  const updateMatch = async () => {
    try {
      await API.put(`/matches/${selectedMatch._id}`, selectedMatch);
      alert("Match modifié ✅");
      fetchMatches();
    } catch (error) {
      console.log(error);
    }
  };

  const deleteMatch = async (id) => {
    const confirmDelete = window.confirm("Supprimer ce match ?");
    if (!confirmDelete) return;

    try {
      await API.delete(`/matches/${id}`);
      setMatches(matches.filter((match) => match._id !== id));
      alert("Match supprimé ✅");
    } catch (error) {
      console.log(error);
    }
  };

  // 🗑️ NOUVELLE FONCTION : SUPPRIMER TOUS LES MATCHS NON AUTORISÉS
  const deleteNonAuthorizedMatches = async () => {
    const countNonAuthorized = matches.filter(m => m.displayStatus === "non_authorise").length;
    
    if (countNonAuthorized === 0) {
      alert("Aucun match non autorisé à supprimer 🚫");
      return;
    }

    const confirmDelete = window.confirm(
      `⚠️ Êtes-vous sûr de vouloir supprimer TOUS les matchs non autorisés (${countNonAuthorized} matchs) ? Cette action est irréversible.`
    );
    if (!confirmDelete) return;

    try {
      const token = localStorage.getItem("token");
      await API.delete("/matches/clean-non-authorized", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      // On met à jour l'état local pour ne garder que ceux qui sont "autorise"
      setMatches(matches.filter((match) => match.displayStatus !== "non_authorise"));
      alert("Tous les matchs non autorisés ont été supprimés ✅");
    } catch (error) {
      console.log(error);
      alert("Erreur lors de la suppression des matchs.");
    }
  };

  // LOGIQUE DE FILTRAGE AMÉLIORÉE
  const filteredMatches = matches.filter((match) => {
    const searchMatch = `${match.homeTeam} ${match.awayTeam}`
      .toLowerCase()
      .includes(search.toLowerCase());

    const dateMatch =
      dateFilter === "" ||
      new Date(match.matchDate).toISOString().split("T")[0] === dateFilter;

    const countryMatch = countryFilter === "" || match.country === countryFilter;
    const accessMatch = accessFilter === "" || match.accessLevel === accessFilter;
    const displayMatch = displayFilter === "" || match.displayStatus === displayFilter;

    let timeMatch = true;
    if (timeUntilStartFilter !== "") {
      const now = new Date();
      const matchTime = new Date(match.matchDate);
      const diffInMs = matchTime - now;
      const hoursUntilStart = diffInMs / (1000 * 60 * 60);
      const maxHours = parseInt(timeUntilStartFilter, 10);
      timeMatch = hoursUntilStart > 0 && hoursUntilStart <= maxHours;
    }

    return searchMatch && countryMatch && accessMatch && displayMatch && dateMatch && timeMatch;
  });

  return (
    <div className="admin-layout">
      {/* MAIN */}
      <div className="main-content">
        {/* TOPBAR */}
        <div className="topbar">
          <h1>Gestion Matchs</h1>
        </div>

        {/* STATS */}
        <div className="stats">
          <div className="stat-card">
            <h3>{matches.length}</h3>
            <p>Matchs</p>
          </div>

          <div className="stat-card">
            <h3>{matches.filter((match) => match.accessLevel === "vip").length}</h3>
            <p>Matchs VIP</p>
          </div>

          <div className="stat-card">
            <h3>{matches.filter((match) => match.displayStatus === "autorise").length}</h3>
            <p>Matchs Publics</p>
          </div>

          {/* 📊 Petite carte bonus pour visualiser les non-autorisés restants */}
          <div className="stat-card" style={{ borderLeft: "4px solid red" }}>
            <h3>{matches.filter((match) => match.displayStatus === "non_authorise").length}</h3>
            <p>Non Autorisés</p>
          </div>
        </div>

        <div className="topbar">
          <button className="import-btn" onClick={importMatches}>
            Importer les matchs
          </button>

          {/* 🔴 LE NOUVEAU BOUTON DE SUPPRESSION MASSIVE */}
          <button 
            className="delete-btn" 
            style={{ backgroundColor: "#d9534f", color: "white", fontWeight: "bold" }} 
            onClick={deleteNonAuthorizedMatches}
          >
            🗑️ Supprimer les non autorisés
          </button>

          <button onClick={() => { window.open("/search"); }} className="search-nav-btn">
            Recherche
          </button>

          <button onClick={() => { window.open("/admin/users"); }} className="search-nav-btn">
            Gestion des utilisateurs
          </button>

           <button onClick={() => { window.open("/admin/compositions"); }} className="search-nav-btn">
            Compos
          </button>

          <button onClick={() => { window.open("/admin/popups"); }} className="search-nav-btn">
            Popups
          </button>
        </div>

        {/* FILTERS */}
        <div className="admin-filters">
          <input
            type="text"
            placeholder="Recherche équipe"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <input
            type="date"
            value={dateFilter}
            onChange={(e) => setDateFilter(e.target.value)}
          />

          <select value={countryFilter} onChange={(e) => setCountryFilter(e.target.value)}>
            <option value="">Tous Pays</option>
            {[...new Set(matches.map((match) => match.country))].sort().map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>

          <select value={accessFilter} onChange={(e) => setAccessFilter(e.target.value)}>
            <option value="">Tous Accès</option>
            <option value="standard">Standard</option>
            <option value="vip">VIP</option>
          </select>

          <select value={displayFilter} onChange={(e) => setDisplayFilter(e.target.value)}>
            <option value="">Tous Affichages</option>
            <option value="autorise">Autorisé</option>
            <option value="non_authorise">Non Autorisé</option>
          </select>

          <select value={timeUntilStartFilter} onChange={(e) => setTimeUntilStartFilter(e.target.value)}>
            <option value="">Débute dans...</option>
            <option value="1">Moins d'1 heure</option>
            <option value="2">Moins de 2 heures</option>
            <option value="3">Moins de 3 heures</option>
            <option value="4">Moins de 4 heures</option>
            <option value="5">Moins de 5 heures</option>
          </select>
        </div>

        {/* TABLE */}
        <div className="table-container">
          <table border="1" cellPadding="10" style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th>Match</th>
                <th>Pays</th>
                <th>Ligue</th>
                <th>Date</th>
                <th>Pronostic</th>
                <th>Statut</th>
                <th>Analyse</th>
                <th>Affichage</th>
                <th>Accès</th>
                <th>Actions</th>
                <th>Ajouter aux compos</th>
              </tr>
            </thead>
            <tbody>
              {filteredMatches.map((match) => (
                <tr key={match._id} className={match.accessLevel === "vip" ? "vip-row" : "standard-row"}>
                  <td>
                    <strong>{match.homeTeam}</strong>
                    {" vs "}
                    <strong>{match.awayTeam}</strong>
                  </td>
                  <td>{match.country}</td>
                  <td>{match.league}</td>
                  <td>{new Date(match.matchDate).toLocaleString()}</td>
                  <td>
                    <div>
                      <strong>Score Exact : </strong>{match.predictions?.scoreExact?.value || "-"}<br />
                      <strong>Score MT : </strong>{match.predictions?.scoreMt?.value || "-"}<br />
                      <strong>BTTS : </strong>{match.predictions?.btts?.value || "-"}<br />
                      <strong>HT/FT : </strong>{match.predictions?.mtFin?.value || "-"}
                    </div>
                  </td>
                  <td>
                    <div>
                      <strong>Score Exact : </strong>{match.predictions?.scoreExact?.status || "-"}<br />
                      <strong>Score MT : </strong>{match.predictions?.scoreMt?.status || "-"}<br />
                      <strong>BTTS : </strong>{match.predictions?.btts?.status || "-"}<br />
                      <strong>HT/FT : </strong>{match.predictions?.mtFin?.status || "-"}
                    </div>
                  </td>
                  <td>
                    <div className="analysis-preview">{match.analysis || "Aucune analyse"}</div>
                  </td>
                  <td>
                    <span style={{ color: match.displayStatus === "autorise" ? "green" : "red", fontWeight: "bold" }}>
                      {match.displayStatus}
                    </span>
                  </td>
                  <td>
                    <span style={{ color: match.accessLevel === "vip" ? "orange" : "blue", fontWeight: "bold" }}>
                      {match.accessLevel}
                    </span>
                  </td>
                  <td>
                    <button className="edit-btn" onClick={() => window.open(`/match/${match._id}`, "_blank")}>
                      Modifier
                    </button>
                    <button className="delete-btn" onClick={() => deleteMatch(match._id)}>
                      Supprimer
                    </button>
                  </td>
                  <td>
                    <button
                      style={{ color: "white", background: "var(--move)" }}
                      onClick={() => toggleCouponPool(match._id)}
                    >
                      {match.availableForCoupons ? "☑ Ajouté" : "☐ Ajouter"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default MatchesPage;